import React from "react";
import { SvgIconProps } from "@material-ui/core/SvgIcon";
import VideocamOutlinedIcon from "@material-ui/icons/VideocamOutlined";
import CropFreeOutlinedIcon from "@material-ui/icons/CropFreeOutlined";
import DirectionsCarOutlinedIcon from "@material-ui/icons/DirectionsCarOutlined";
import TextFieldsOutlinedIcon from "@material-ui/icons/TextFieldsOutlined";
import CategoryOutlinedIcon from "@material-ui/icons/CategoryOutlined";
import BlurOnOutlinedIcon from "@material-ui/icons/BlurOnOutlined";
import LabelOutlinedIcon from "@material-ui/icons/LabelOutlined";
import { formatLabelingType } from "./utils";

const LABELING_TYPE_ICONS: Record<string, React.ComponentType<SvgIconProps>> = {
  VIDEO: VideocamOutlinedIcon,
  RECTANGLE_BOXING: CropFreeOutlinedIcon,
  PLATE: DirectionsCarOutlinedIcon,
  PLATE_TEXT: TextFieldsOutlinedIcon,
  CLASSIF: CategoryOutlinedIcon,
  SEGMENTATION: BlurOnOutlinedIcon,
};

interface Props {
  labelingType?: string | null;
  className?: string;
}

const LabelingTypeIcon = ({ labelingType, className }: Props) => {
  const Icon = (labelingType && LABELING_TYPE_ICONS[labelingType]) || LabelOutlinedIcon;
  const title = formatLabelingType(labelingType);

  return (
    <Icon
      className={className}
      fontSize="small"
      aria-label={title}
      titleAccess={title}
    />
  );
};

export default LabelingTypeIcon;
